module.exports = __webpack_public_path__ + "img/Artboard – 1 (5).f4e1701d.png";